import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  createErrorMessage: {
    margin: theme.spacing(1, 1, 0),
    color: theme.palette.error.main,
    fontWeight: 600,
    fontSize: '0.95rem',
    lineHeight: 1.35,
  },
}));

type CreateVisitErrorMessageProps = {
  message: string | null;
};

/** Persistent in-form create-visit error (not a transient toast). */
export const CreateVisitErrorMessage = ({
  message,
}: CreateVisitErrorMessageProps) => {
  const classes = useStyles();
  if (!message) {
    return null;
  }
  return (
    <p className={classes.createErrorMessage} role="status">
      {message}
    </p>
  );
};
